<div class="row">
    <div class="col-sm-6">
        <h2>Admins</h2>
    </div>
    <div class="col-sm-4">
        <input
          style="float: right; background-color: white"
          type="text"
          placeholder="Search Text"
          nbInput
          [(ngModel)]="word"
          (keyup)="onFilterKeySearch()"
        />
      </div>
    <div class="col-sm-2">
        <button type="button" class="btn btn-primary px-4" style="float: right;" (click)="addAdmin()"> Add Admin
        </button>
    </div>
    
</div>
<div class="col-12" style="margin-top: 20px;">
    <nb-card>
        <nb-card-body>
            <table class="table text-center">
                <thead>
                    <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone No.</th>
                        <th scope="col">Profile Image</th>
                        <th scope="col">Role</th>
                        <th scope="col">Chains</th>
                        <th scope="col">Store Id</th>
                        <th scope="col">Action</th>

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of source| paginate : { itemsPerPage: 10, currentPage: page, totalItems: total };let i = index">
                        <td>{{(page - 1) * count + i + 1 + ((page - 1) * count)}}</td>
                        <td>{{user.name}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.phone}}</td>
                        <td><img [src]='imagePath+user.profileImage' height="50"  /></td>
                        <td>{{user.role}}</td>
                        <td>{{ user.chainId?.length > 0 ? user.chainId.length + ' chain(s)' : '-' }}</td>
                        <td>{{ user.storeId?.length > 0 ? user.storeId.length + ' store(s)' : '-' }}</td>
                        <td> <nb-icon style="cursor: pointer;" (click)="editAdmin(user._id)" class="right"
                            icon="edit-outline"></nb-icon> <nb-icon style="cursor: pointer;"
                            (click)="deleteAdmin(user._id)" class="right deleteIcon" icon="trash-outline"></nb-icon></td>


                    </tr>
                </tbody>
            </table>
            <pagination-controls class="pagination" [responsive]="true" (pageChange)="pageChanged($event)"
            previousLabel="Prev" nextLabel="Next"></pagination-controls>
        </nb-card-body>
    </nb-card>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>